var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h3", [_vm._v("指针调整")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "block-demo",
        {
          attrs: {
            tip: "",
            source:
              "\nconst { Chart, Gauge, Legend, Tooltip } = qcharts\n\nconst chart = new Chart({ container: '#app' })\n\nconst gauge = new Gauge({\n  min: 0,\n  max: 100,\n  percent:45,\n  lineWidth: 20,\n  // 修改指针宽度\n  pointerWidth: 10,\n  tickStep: 10\n})\n\ngauge\n  .style('title', { fontSize: 36 })\n  .style('arc', { strokeColor: '#006666' })\n  .style('pointer', { fillColor: '#006666' })\n\nchart.append(gauge)\n\nsetInterval(() => {\n  const val = (Math.random() * 100).toFixed(0)\n  gauge.attr({\n    percent:val\n  })\n}, 3000)\n"
          }
        },
        [
          _c("pre", { pre: true }, [
            _c(
              "code",
              {
                pre: true,
                attrs: { "v-pre": "", class: "language-javascript" }
              },
              [
                _vm._v("\n"),
                _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                  _vm._v("const")
                ]),
                _vm._v(" { Chart, Gauge, Legend, Tooltip } = qcharts\n\n"),
                _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                  _vm._v("const")
                ]),
                _vm._v(" chart = "),
                _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                  _vm._v("new")
                ]),
                _vm._v(" Chart({ "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("container")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
                  _vm._v("'#app'")
                ]),
                _vm._v(" })\n\n"),
                _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                  _vm._v("const")
                ]),
                _vm._v(" gauge = "),
                _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                  _vm._v("new")
                ]),
                _vm._v(" Gauge({\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("min")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("0")
                ]),
                _vm._v(",\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("max")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("100")
                ]),
                _vm._v(",\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("percent")
                ]),
                _vm._v(":"),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("45")
                ]),
                _vm._v(",\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("lineWidth")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("20")
                ]),
                _vm._v(",\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
                  _vm._v("// 修改指针宽度")
                ]),
                _vm._v("\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("pointerWidth")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("10")
                ]),
                _vm._v(",\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("tickStep")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("10")
                ]),
                _vm._v("\n})\n\ngauge\n  .style("),
                _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
                  _vm._v("'title'")
                ]),
                _vm._v(", { "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("fontSize")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("36")
                ]),
                _vm._v(" })\n  .style("),
                _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
                  _vm._v("'arc'")
                ]),
                _vm._v(", { "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("strokeColor")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
                  _vm._v("'#006666'")
                ]),
                _vm._v(" })\n  .style("),
                _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
                  _vm._v("'pointer'")
                ]),
                _vm._v(", { "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("fillColor")
                ]),
                _vm._v(": "),
                _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
                  _vm._v("'#006666'")
                ]),
                _vm._v(" })\n\nchart.append(gauge)\n\nsetInterval("),
                _c("span", { pre: true, attrs: { class: "hljs-function" } }, [
                  _c("span", { pre: true, attrs: { class: "hljs-params" } }, [
                    _vm._v("()")
                  ]),
                  _vm._v(" =>")
                ]),
                _vm._v(" {\n  "),
                _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                  _vm._v("const")
                ]),
                _vm._v(" val = ("),
                _c("span", { pre: true, attrs: { class: "hljs-built_in" } }, [
                  _vm._v("Math")
                ]),
                _vm._v(".random() * "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("100")
                ]),
                _vm._v(").toFixed("),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("0")
                ]),
                _vm._v(")\n  gauge.attr({\n    "),
                _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
                  _vm._v("percent")
                ]),
                _vm._v(":val\n  })\n}, "),
                _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
                  _vm._v("3000")
                ]),
                _vm._v(")\n")
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("可以通过 "),
      _c("code", { pre: true }, [_vm._v("pointerWidth")]),
      _vm._v(" 调整指针的宽度，值为"),
      _c("code", { pre: true }, [_vm._v("Number")]),
      _vm._v("或者"),
      _c("code", { pre: true }, [_vm._v("Array")]),
      _vm._v("。值若为"),
      _c("code", { pre: true }, [_vm._v("Array")]),
      _vm._v("，维度与 data 的维度保持一致；如果为"),
      _c("code", { pre: true }, [_vm._v("Number")]),
      _vm._v("则所有仪表盘的"),
      _c("code", { pre: true }, [_vm._v("pointerWidth")]),
      _vm._v("都为相同值。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("指针支持通过 "),
      _c("code", { pre: true }, [_vm._v("style('pointer')")]),
      _vm._v("对颜色及属性进行修改")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }